<template>
  <div class="workflow-json-edit-new main">
    <div class="wrapper">
      <p class="header" @click="close">
        <i class="fa fa-chevron-left" style="padding-right: 4px" />
        {{ w.workflow_type_name }}
        <span class="is-pulled-right">Edit Workflow</span>
      </p>

      <div class="field" style="margin-bottom: -2px">
        <p class="control has-icons-right">
          <input class="input is-medium" v-model="w.name" type="text" placeholder="Workflow Name" />
          <span class="icon is-right" style="pointer-events: auto" @click="workflowNameInfo">
            <i class="fa fa-info-circle has-text-grey" />
          </span>
        </p>
      </div>

      <div class="field">
        <div class="control">
          <textarea class="textarea has-text-weight-medium no-scrollbar" :style="jsonStyle" v-model="dataJSON"
            placeholder="Data JSON" rows="100"></textarea>
        </div>
      </div>

      <div class="field is-grouped" style="margin: 0 10px">
        <p class="control">
          <button class="button is-outlined has-text-grey" :class="{ 'is-danger': invalidJSON }"
            @click="showEditOptions = true">
            <span class="icon" style="margin-right: 4px">
              <i class="fa fa-pencil-alt fa-sm" /> </span>Edit
          </button>
        </p>
        <p class="control is-expanded">
          <button class="button is-success is-outlined is-fullwidth" @click="submit">
            <i class="fa fa-save" />&nbsp;{{ $t("save") }}
          </button>
        </p>
      </div>

      <div v-if="showEditOptions" class="edit-options">
        <div style="font-size:1.1em; margin-bottom:10px;" @click="showEditOptions = false">Edit Options
          <i class="fa fa-times-circle fa-lg is-pulled-right" />
        </div>
        <p>
          delivery_options.type = delayed
        </p>
        <p>
          something else
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus.js";

export default {
  name: "WorkflowJSONEditNew",
  components: {},
  props: {
    workflow: Object,
  },
  data() {
    return {
      w: {
        name: "",
      },
      dataJSON: null,
      invalidJSON: false,
      showEditOptions: false,
    };
  },
  computed: {
    jsonStyle() {
      if (this.invalidJSON) return "color:lightpink";
      return "color:lightgreen"; // light yellow
    },
  },
  mounted() {
    this.w = this.workflow;
    this.dataJSON = JSON.stringify(this.w.data, null, 2);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    workflowNameInfo() {
      var msg = `<div style='text-align:left'>Enter workflow name<br>Edit this for Fleet workflows<br>E.g. Motorbike, Tuk Tuk, Taxi</div>`;
      this.infoToast(msg, "top", 10000);
    },
    prettyJSON(str) {
      return JSON.stringify(JSON.parse(str), null, 2);
    },
    isValidJSON() {
      try {
        JSON.parse(this.dataJSON);
      } catch (e) {
        this.invalidJSON = true;
        this.errorToast("Invalid JSON", "top");
        return false;
      }
      this.invalidJSON = false;
      this.infoToast("Valid JSON", "top");
      return true;
    },
    parseJSON() {
      var loader = this.loadingDots("lightgreen");
      if (this.isValidJSON()) {
        this.dataJSON = this.prettyJSON(this.dataJSON);
      }
      setTimeout(() => loader.hide(), 200);
    },
    submit() {
      this.parseJSON();
      if (this.invalidJSON) {
        var msg = `Invalid JSON<br><br>Check keys are quoted<br>and comma-separated`;
        return this.errorToast(msg, "top");
      }
      var businessID = this.$store.state.selectedBusiness.id;
      var loader = this.loadingDots("lightgreen");
      console.log("updateWorkflow", this.w);
      this.$store
        .dispatch("updateWorkflow", {
          id: this.w.id,
          business_id: this.w.business_id,
          name: this.w.name,
          data: JSON.parse(this.dataJSON),
          // { phone_number: this.phoneNumber, info: this.workflowInfo, operating_hours: this.operatingHours }
        })
        .then(() => {
          this.$store
            .dispatch("getWorkflows", businessID)
            .then(() => {
              this.close();
              this.successToast("JSON Saved!", "top");
            })
            .catch((err) => this.apiError(err));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255);
  z-index: 21;
  overflow: hidden;
}

.wrapper {
  text-align: left;
  height: 100vh;
  overflow: hidden;
}


.field {
  margin-bottom: 6px;
}

textarea {
  border-radius: 0px;
  max-height: calc(100vh - 150px);
  /* background-color: slategray; */
  background-color: #1f1a24;
}

.header {
  text-align: left;
  font-size: 1.3em;
  /* font-weight: 500; */
  /* padding-left: 8px; */
  /* margin-bottom: 6px; */
  padding: 8px 12px;
}

.header span {
  color: black;
  opacity: 0.5;
  font-size: 0.9em;
}

.edit-options {
  position: absolute;
  bottom: 0;
  padding: 12px;
  padding-bottom: 20px;
  background-color: black;
  color: lightyellow;
  width: 100vw;
}

.edit-options p {
  padding: 6px;
  border-top: 1px solid #333;
}
</style>